module.exports = function () {
	var $filterButton = $('.C3-filter__button');
	var $filterTitle = $('.C3-filter__header__title');
	var $filterWrapper = $('.C3-filter__wrapper');
	var $filterButton = $('.C3-filter__button');
	var $filterCloseButton = $('.C3-filter__tablet-close');
	var adjustFilterClasses = function () {
		if (window.innerWidth >= 992) {
			$filterWrapper.removeClass('is-device');
			$filterWrapper.addClass('is-open');

			$filterButton.removeClass('is-device').addClass('is-desktop');
		}
		else {
			$filterWrapper.addClass('is-device');
			$filterWrapper.removeClass('is-open');

			$filterButton.addClass('is-device').removeClass('is-desktop');
		}
	};

	$(window).resize(function () {
		requestAnimationFrame(adjustFilterClasses);
	});

	adjustFilterClasses();

	$filterButton.click(function () {
		$filterWrapper.toggleClass('is-open');
	});

	$filterTitle.click(function () {

		if (window.innerWidth < 992) {
			$filterWrapper.toggleClass('is-open');
		}

	});

	$filterCloseButton.click(function () {
		$filterWrapper.removeClass('is-open');
	});

	var $filterPanelTitle = $('.C3-filter__panel__section-title');

	$filterPanelTitle.click(function () {
		if ($(this).parent('.C3-filter__panel').hasClass("is-open")) {
			$(this).closest(".C3-filter__collapsible").find(".C3-filter__panel.is-open").removeClass("is-open");
		} else {
			$(this).closest(".C3-filter__collapsible").find(".C3-filter__panel.is-open").removeClass("is-open");
			$(this).parent('.C3-filter__panel').addClass('is-open');
		}
		
    });

    $(document).click(function (e) {
        /// Click outside dropdown event
        if ($(e.target).closest(".C3-filter__panel__section-title, .C3-filter__panel__category-list").length == 0) {
             $(".C3-filter__collapsible").find(".C3-filter__panel.is-open").removeClass("is-open");
        }
    });

	var $topLevelCheckboxes = $('.C3-filter__panel__category-item').children('.C3-filter__field')
		.find('input[type="checkbox"]');

	$topLevelCheckboxes.on('click', function (e) {
		var isChecked = $(this).is(':checked');
		var shouldSearch = false;

		if (isChecked) {
			$(this).closest('.C3-filter__panel__category-item')
				.find('.C3-filter__panel__topic-list input[type=checkbox]')
				.each(function() {
					this.checked = true;
					var currentNestedValue = $(this).val();
					var currentNestedIndex = window.searchFilters.facetIds.indexOf(currentNestedValue);
					if (currentNestedIndex == -1) {
						window.searchFilters.facetIds.push(currentNestedValue);
						shouldSearch = true;
					}
					else if (currentNestedValue != -1) {
						window.searchFilters.facetIds.splice(currentNestedIndex, 1);
						shouldSearch = true;
					}
				});
		} else {
			$(this).closest('.C3-filter__panel__category-item')
				.find('.C3-filter__panel__topic-list input[type=checkbox]')
				.each(function() {
					this.checked = false;
					var currentNestedValue = $(this).val();
					var currentNestedIndex = window.searchFilters.facetIds.indexOf(currentNestedValue);

					if (currentNestedValue != -1) {
						window.searchFilters.facetIds.splice(currentNestedIndex, 1);
						shouldSearch = true;
					}
				});
		}

		if (shouldSearch) {
			Innophos.Pages.ProductSearchPage.InsertResults(false);
		}
	});

	var $nestedCheckboxes = $('.C3-filter__panel__topic-item input[type="checkbox"]');
	$nestedCheckboxes.on('click', function (e) {
		var isChecked = $(this).is(':checked');
		var currentValue = $(this).val();
		var currentIndex = window.searchFilters.facetIds.indexOf(currentValue);
		var shouldSearch = false;

		var parent = $(this).closest('.C3-filter__panel__category-item')
			.children('.C3-filter__field')
			.find('input[type=checkbox]');

		var siblings = $(this).closest('.C3-filter__panel__category-item')
			.children('.C3-filter__panel__topic-list')
			.find('input[type=checkbox]:checked');

		if (isChecked || siblings.length) {
			parent.prop('checked', true);
		} else {
			parent.prop('checked', false);
		}

		if (isChecked && currentIndex == -1) {
			window.searchFilters.facetIds.push(currentValue);
			shouldSearch = true;
		}

		else if (currentValue != -1) {
			window.searchFilters.facetIds.splice(currentIndex, 1);
			shouldSearch = true;
		}

		if (shouldSearch) {
			Innophos.Pages.ProductSearchPage.InsertResults(false);
		}
	});

	var $nestedListToggle = $('.C3-filter__panel__topic-toggle');
	$nestedListToggle.click(function (e) {
		e.preventDefault();

		var $parentList = $(this).parent('.C3-filter__panel__category-item');

		if ($parentList.hasClass('is-open')) {
			$parentList.removeClass('is-open');
		} else {
			$parentList.addClass('is-open');
		}
	});

	var $clearAllFiltersCTA = $('.C3-filter__header__action');
	$clearAllFiltersCTA.click(function (e) {
		$topLevelCheckboxes.each(function (index, item) {
			$(item).prop('checked', false);
		});

		$nestedCheckboxes.each(function (index, item) {
			$(item).prop('checked', false);
		});

		window.searchFilters['facetIds'] = [];
		window.page = 1;

		Innophos.Pages.ProductSearchPage.InsertResults(false);
	});
};
